import { ApButtonMain } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const PageWrapper = styled.div`
  padding: 24px;
  background-color: #f1f1f1;
  min-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const PageTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PageTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 19px;
  line-height: 20px;
  color: #000000;
`;

export const PageSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const NotesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NotesLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #000000;
`;

export const NotesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
`;

export const InfoBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  background-color: #f6fdff;
  border: 1px solid #b0deeb;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #3b4648;
  white-space: nowrap;
`;

export const Card = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const CardTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 17px;
  line-height: normal;
  color: #000000;
`;

export const CardSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const CardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Divider = styled.div`
  width: 1px;
  height: 32px;
  background-color: #c4c4c4;
`;

export const TableWrapper = styled.div`
  border: 1px solid #e4e4e4;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 8px 16px;
  background-color: #ffffff;
`;

export const ColHeader = styled.div<{
  width?: string;
  alignRight?: boolean;
  fillWidth?: boolean;
}>`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #737373;
  white-space: nowrap;
  ${({ fillWidth }) => fillWidth && 'flex: 1; min-width: 0;'}
  ${({ fillWidth, width }) =>
    !fillWidth && width != null && `width: ${width}; flex-shrink: 0;`}
  ${({ alignRight }) => alignRight && 'margin-left: auto; text-align: right;'}
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px;
  background-color: #ffffff;
  filter: drop-shadow(0px -1px 0px #cccccc);
`;

export const FileIconContainer = styled.div`
  width: 32px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f1f1f1;
  border-radius: 4px;
  flex-shrink: 0;
`;

export const FileNameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const FileName = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CellText = styled.div<{ width?: string }>`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  width: ${({ width }) => width || 'auto'};
  flex-shrink: 0;
`;

export const ActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

export const SecondaryDangerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  min-width: 94px;
  padding: 0 12px;
  background-color: #ffffff;
  border: 1px solid #cb282e;
  border-radius: 2px;
  cursor: pointer;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  color: #cb282e;
  white-space: nowrap;
`;

export const TableLoadingRow = styled.div`
  padding: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #737373;
  filter: drop-shadow(0px -1px 0px #cccccc);
`;

export const TableEmptyRow = styled.div`
  padding: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: #737373;
  filter: drop-shadow(0px -1px 0px #cccccc);
`;

export const RowIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
`;

export const UpdateReportsButton = styled(ApButtonMain)`
  && {
    height: 32px;
    background-color: #498e2b;
  }
  && span {
    font-size: 15px;
    letter-spacing: 0.3px;
  }
  &&:not([disabled]):hover,
  &&:not([disabled]):focus {
    background-color: #3f7b25;
  }
`;

export const ProgressError = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #cb282e;
`;
